import ResourcesList from "../views/ResourcesList"
import ResourceDetail from "../views/ResourceDetail"
import ResourceContent from "../views/ResourceContent"

export default [
	{
		path: "/:tenantId/resources",
		component: ResourcesList,
		name: "ResourcesList",
		meta: { featureId: "resources" },
		props: true
	},
	{
		path: "/:tenantId/resources/detail/:id",
		component: ResourceDetail,
		name: "ResourceDetail",
		meta: { featureId: "resources" },
		props: true
	},
	{
		path: "/:tenantId/resources/detail/:id/content",
		component: ResourceContent,
		name: "ResourceContent",
		meta: { featureId: "resources" },
		props: true
	}
]
